// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QlXE","controls":"styles_controls__19Sjt","charLimit":"styles_charLimit__3-S-R","input":"styles_input__28ucb","send":"styles_send__3XWU8"};